// src/routes.js
import Billing from "layouts/billing";
import Event from "layouts/event";
import Approval from "layouts/approval";
import Profile from "layouts/profile/index";
import ProfileInfo from "layouts/profile/indexProfile";
import ProfileAdmin from "layouts/profile/indexAdmin";
import SignIn from "layouts/authentication/sign-in";
import SignUpDXP from "layouts/authentication/sign-up/dxpbooth";
import Cube from "examples/Icons/Cube";
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";
import Tables from "layouts/tables";
import Dashboard from "layouts/dashboard";

export const routesuser = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Shop size="12px" />,
    component: <Profile />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/profile",
    icon: <CustomerSupport size="12px" />,
    component: <ProfileInfo />,
    noCollapse: true,
  },
  {
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    route: "/authentication/sign-up/dxpbooth",
    component: <SignUpDXP />,
  },
];

export const routesadmin = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Shop size="12px" />,
    component: <ProfileAdmin />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Approval",
    key: "approval",
    route: "/approval",
    icon: <Office size="12px" />,
    component: <Approval />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/profile",
    icon: <CustomerSupport size="12px" />,
    component: <ProfileInfo />,
    noCollapse: true,
  },
  {
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    route: "/authentication/sign-up",
    component: <></>,
  },
];

export const routesorganizer = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Shop size="12px" />,
    component: <ProfileAdmin />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Events",
    key: "events",
    route: "/events",
    icon: <CreditCard size="12px" />,
    component: <Event />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/profile",
    icon: <CustomerSupport size="12px" />,
    component: <ProfileInfo />,
    noCollapse: true,
  },
  {
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    route: "/authentication/sign-up",
    component: <></>,
  },
];

export const defaultroute = [
  {
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    route: "/authentication/sign-up/dxpbooth",
    component: <SignUpDXP />,
  },
];
